<template>
  <div class="failed-sends-edit-address-panel">
    <loqate-autocomplete
      v-if="!enterAddressManually"
      :street.sync="form.street"
      :city.sync="form.city"
      :country.sync="form.country"
      :postcode.sync="form.postcode"
      :region.sync="form.region"
      :availableCountries="availableCountries"
      @onSelectedAddress="enterAddressManually = true"
      ref="loqateAutocomplete"
    >
      <template #label>
        <div class="failed-sends-edit-address-panel__autocomplete-label">
          Street address
          <span @click.prevent="enterAddressManually = true">Enter address manually</span>
        </div>
      </template>
    </loqate-autocomplete>
    <cg-form ref="form" class="failed-sends-edit-address-panel__form">
      <cg-input v-if="enterAddressManually" v-model="form.street" :validation="[validation.required]">
        <template #label>Street address</template>
      </cg-input>
      <cg-input v-model="form.city" :validation="[validation.required]">
        <template #label>City</template>
      </cg-input>
      <cg-country-select v-model="form.country">
        <template #label>Country</template>
      </cg-country-select>
      <cg-state-select
        v-model="form.region"
        :country="form.country"
        :validation="[validation.required]"
      >
        <template #label>State</template>
      </cg-state-select>
      <cg-input v-model="form.postcode" :validation="[validation.required]">
        <template #label>Postal code</template>
      </cg-input>
      <cg-phone-input v-model="form.telephone" :validation="[validation.required]">
        <template #label>Phone</template>
      </cg-phone-input>
      <cg-checkbox v-if="showSaveContactCheckbox" v-model="form.checked">
        Save updated address for this contact
      </cg-checkbox>
      <cg-button @click="validate"> Save changes </cg-button>
    </cg-form>
  </div>

</template>
<script>
import {
  CgCountrySelect,
  CgForm,
  CgInput,
  CgPhoneInput,
  CgStateSelect,
  CgButton,
  CgCheckbox,
} from '@corporategiftcom/design-system';
import { required } from '@corporategiftcom/design-system/validations';
import LoqateAutocomplete from '@/components/payment/LoqateAutocomplete.vue';

export default {
  name: 'TheEditAddressPanel',
  components: {
    CgForm,
    CgInput,
    CgPhoneInput,
    CgCountrySelect,
    CgStateSelect,
    CgButton,
    CgCheckbox,
    LoqateAutocomplete,
  },
  data: () => ({
    form: {
      checked: false,
      street: null,
      city: null,
      postcode: null,
      region: null,
      telephone: null,
      country: 'US',
    },
    enterAddressManually: false,
    validation: {
      required: required(),
    },
    isLoqateSelected: false,
  }),
  props: {
    /**
     * An array of available countries for Loqate
     * Empty Array means all countries are available
     */
    availableCountries: {
      type: Array,
      required: false,
      default: () => [],
    },
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    showSaveContactCheckbox() {
      return this?.item?.automation?.source === 'contacts' ?? false;
    },
  },
  created() {
    const r = this.item.recipient || {};
    this.form = {
      checked: false,
      street: r.street || null,
      city: r.city || null,
      postcode: r.postcode || null,
      region: r.region || null,
      telephone: r.telephone || null,
      country: r.country || 'US',
    };
  },
  methods: {
    validate() {
      const isFormValid = this.$refs.form?.validate()

      if (this.enterAddressManually) {
        if (!isFormValid) return

        this.$emit('save', this.form)
        this.$cgToast.successBold("Contact's address will be updated upon sending this campaign.")
        return
      }

      if (!isFormValid) return

      const isStreetValid = this.form.street && this.form.street.length > 1

      if (!isStreetValid) {
        this.$refs.loqateAutocomplete?.validate()
        return
      }

      this.$emit('save', this.form)
      this.$cgToast.successBold("Contact's address will be updated upon sending this campaign.")
    }
  },
};
</script>

<style lang="scss" scoped>
.failed-sends-edit-address-panel {
  display: flex;
  flex-direction: column;
  gap: 30px;
  width: 451px;

  &__form {
    display: flex;
    flex-direction: column;
    gap: 30px;
  }

  &__autocomplete-label {
    display: flex;
    gap: 20px;
    flex-direction: row;
    justify-content: space-between;

    > span {
      color: #6e50ff;
      cursor: pointer;
      font-size: 15px;
      font-family: 'Lato-Regular', sans-serif;
      font-weight: 400;
    }
  }

  .cg-button {
    width: fit-content;
    border-radius: 100px;
  }
}
</style>
